<template>
  <div class="screen-call">
    <section class="call-header">
      <div v-if="title !== '911'" class="call-logo">
        <img v-if="logo === 'sos'" src="../assets/icons/sos.png" alt="logo" />
        <img
          v-else-if="logo === 'onstar'"
          src="../assets/icons/onstar.png"
          alt="logo"
        />
        <img v-else src="../assets/icons/roadside.png" alt="logo" />
      </div>
      <h3 v-bind:title="title">{{ title || "Loading..." }}</h3>
      <section class="call-timer" v-on:click="startTimer">
        <span>{{ counter || "00:00" }}</span>
      </section>
    </section>
    <section class="call-actions">
      <div class="call-actions-inner">
        <ul>
          <li class="call-mute">
            <img
              src="../assets/icons/mute.png"
              alt="Mute"
              class="call-icon"
              title="Mute"
            />
            <span class="call-action-label">Mute</span>
          </li>
          <li class="call-speaker">
            <img
              src="../assets/icons/speaker.png"
              alt="Speaker"
              class="call-icon"
              title="Speaker"
            />
            <span class="call-action-label">Speaker</span>
          </li>
          <li class="call-bluetooth">
            <img
              src="../assets/icons/bluetooth.png"
              alt="Bluetooth"
              class="call-icon"
              title="Bluetooth"
            />
            <span class="call-action-label">Bluetooth</span>
          </li>
        </ul>
        <div class="flex">
          <img
            @click="nav"
            src="../assets/icons/end-call.png"
            alt="End Lock"
            class="call-icon call-end"
            title="End call"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "CallScreen",
  props: {
    logo: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "SOS",
      required: true,
    },
  },
  data() {
    return {
      counter: "00:00",
      startTime: "",
      updatedTime: "",
      difference: "",
      timeInterval: "",
      savedTime: "",
      paused: 0,
      running: 0,
      routeFlag: false,
    }
  },
  mounted: function() {
    this.startTimer()
    this.routeFlag = this.$route.params.routeBoolean
  },
  methods: {
    nav() {
      this.$router.push("/home")
    },
    startTimer() {
      if (!this.running) {
        this.startTime = new Date().getTime()
        this.timeInterval = setInterval(() => this.getTimer(), 1000)
        this.paused = 0
        this.running = 1
      }
    },
    getTimer() {
      this.updatedTime = new Date().getTime()

      if (this.savedTime) {
        this.difference = this.updatedTime - this.startTime + this.savedTime
      } else {
        this.difference = this.updatedTime - this.startTime
      }

      let minutes = Math.floor(
        (this.difference % (1000 * 60 * 60)) / (1000 * 60)
      )
      let seconds = Math.floor((this.difference % (1000 * 60)) / 1000)
      let counter

      minutes = minutes < 10 ? "0" + minutes : minutes
      seconds = seconds < 10 ? "0" + seconds : seconds
      counter = minutes + ":" + seconds

      this.counter = counter
    },
  },
  computed: {
    routeBool() {
      return this.$route.params.routeBoolean
    },
  },
}
</script>

<style lang="scss" scoped>
.screen-call {
  position: absolute;
  top: 0;
  background-color: #0d1220;
  color: white;
  height: 100%;
  width: 100%;
  font-size: 1.5rem;
  flex-direction: column;
  box-sizing: border-box;
  margin-left: 10px;

  @media only screen and (max-height: 900px) {
    padding: 0 2% 0 0;
  }

  section {
    flex-grow: 1;
    padding: 10px 0;
    box-sizing: border-box;
    height: auto;
  }

  .call-header {
    padding-top: 8vh;
    box-sizing: border-box;

    .call-logo {
      width: 97%;
    }

    img {
      width: 75px;
      height: auto;
    }

    @media only screen and (min-height: 900px) {
      img {
        width: 155px;
      }
    }
  }
  .call-timer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 97%;

    span {
      font-size: 3rem;
      font-weight: bold;
    }

    @media only screen and (min-height: 900px) {
      span {
        font-size: 4.5rem;
      }
    }
  }

  @media only screen and (min-height: 900px) {
    h3 {
      font-size: 2rem;
      width: 90%;
      margin: 5%;
    }
  }
  .call-actions {
    display: flex;
    margin-top: 4vh;

    .call-actions-inner {
      width: 100%;
      margin: auto;

      ul {
        position: absolute;
        bottom: 30%;
        left: 0.5%;
        width: 96%;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        list-style: none;
        justify-content: center;
        flex-basis: 0;

        @media only screen and (max-width: 600px) {
          left: 3.25%;
        }

        @media only screen and (max-height: 900px) {
          left: 5%;
          width: 93%;
        }

        li {
          text-align: center;
          flex-basis: 0;
          font-size: 1.3rem;
          min-width: 30%;
          height: auto;

          img {
            width: 50%;
            height: auto;
          }

          .call-action-label {
            display: block;
          }
        }
      }

      .flex {
        display: flex;
        justify-content: center;
        width: 99%;
        position: absolute;
        left: 0;
        bottom: 15%;

        .call-icon {
          cursor: pointer;
          width: 15%;
          height: 15%;

          &:hover {
            opacity: 0.9;
          }
        }
        .call-end {
          margin: 0 10px 0 0;
        }
      }
    }
  }
}
</style>
